import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getAsistencia, getEmpleado, getEvaluacionesEmpleado } from "../../shared/evaluacionesApi";

export function useBusquedaEvaluaciones() {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tipo = query.get("tipo") === "servicio" ? "servicio" : "empleado";
  const consulta = query.get("q") || "";
  const buscado = query.has("q");
  const origen = location.pathname + location.search;
  const [texto, setTexto] = useState(consulta);
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");
  const [busqueda, setBusqueda] = useState(0);

  useEffect(() => {
    setTexto(consulta);
  }, [consulta, tipo]);

  useEffect(() => {
    setFilas([]);
    setError("");
    if (!buscado) {
      setCargando(false);
      return;
    }

    let vigente = true;
    setCargando(true);
    let request;
    if (!consulta) {
      request = getEvaluacionesEmpleado();
    } else if (tipo === "empleado") {
      request = getEmpleado(consulta);
    } else {
      request = getAsistencia(consulta);
    }
    request
      .then(data => {
        if (vigente) setFilas(data);
      })
      .catch(error => {
        if (vigente) setError(error.message);
      })
      .finally(() => {
        if (vigente) setCargando(false);
      });

    return () => {
      vigente = false;
    };
  }, [buscado, consulta, tipo, busqueda]);

  const cambiarTipo = value => {
    setTexto("");
    history.push(`/evaluaciones?tipo=${value}`);
  };

  const buscar = event => {
    event.preventDefault();
    setBusqueda(actual => actual + 1);
    history.push(`/evaluaciones?tipo=${tipo}&q=${encodeURIComponent(texto.trim())}`);
  };

  const nuevaEvaluacion = () => {
    history.push({ pathname: "/evaluaciones/nueva", state: { origen } });
  };

  return {
    tipo, texto, filas, cargando, error, buscado, origen,
    setTexto, cambiarTipo, buscar, nuevaEvaluacion,
  };
}
